module.exports = __webpack_public_path__ + "static/media/vrtbck.7e9ba301.png";